import React from 'react';
import './Hero.scss';
import Button from 'Components/Shared/Button/Button';
import DateSpan from 'Components/Shared/DateSpan/DateSpan';
import LocationSpan from 'Components/Shared/LocationSpan/LocationSpan';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isFetching: boolean;
  heroEvents: Julius.Website.EventOverviewViewModel[];
  onClick: (eventID: number) => void;
}

const Hero: React.SFC<IProps> = ({
  isFetching,
  heroEvents,
  onClick,
}) => {

  if (isFetching || !heroEvents || !heroEvents.length) {
    return null;
  }

  const MainEvent = () => (
    <div className='main-event container'>
      <EventBox event={ heroEvents[0] } onClick={ onClick } />
    </div>
  );

  if (heroEvents.length < 3) {
    return (
      <WrapperLayout style='hero' padding='xs' justify='space-between'>
        <MainEvent />
      </WrapperLayout>
    );
  }

  const SubEvents = () => (
    <div className='sub-events container'>
      <EventBox event={ heroEvents[1] } onClick={ onClick } />
      <EventBox event={ heroEvents[2] } onClick={ onClick } />
    </div>
  );

  return (
    <WrapperLayout style='hero' padding='xs' justify='center'>
      <MainEvent />
      <SubEvents />
    </WrapperLayout>
  );
}

const EventBox: React.SFC<{
  event: Julius.Website.EventOverviewViewModel;
  onClick: (eventID: number) => void;
}> = ({
  event: {
    id,
    imageLargeUrl,
    name,
  },
  onClick,
}) => (  
  <div 
    className='event-box'
    onClick={ () => onClick(id) }
  >
    <img alt={ name } src={ `${ imageLargeUrl }` } className='event-image' />
    <div className='button-container'>
      <Button boxShadow={ true }>
        <FormattedText
          displayName='Läs mer & boka'
          formattedName='events.showmoreandbook'
        />
      </Button>
    </div>
  </div>
);

export default Hero;


// WEBPACK FOOTER //
// ./src/components/Hero/Hero.tsx